import * as React from "react";
import { Typography, DatePicker, InputNumber, Button } from "antd";
import moment from "moment";
import { DateFormats, EvaluationStatuses } from "../../../common/Constants";
import SelectInput from "../app/SelectInput";

const Report2ParamBox = ({
  translate,
  periodFrom,
  onPeriodFromChange,
  periodTo,
  onPeriodToChange,
  min,
  onMinChange,
  max,
  onMaxChange,
  evaluationStatus,
  onEvaluationStatusChange,
  getPDFReport,
  loading
}: {
  translate: any;
  periodFrom: Date | undefined;
  onPeriodFromChange: (date: Date) => void;
  periodTo: Date | undefined;
  onPeriodToChange: (date: Date) => void;
  min: number | undefined;
  onMinChange: (min?: number) => void;
  max: number | undefined;
  onMaxChange: (max?: number) => void;
  evaluationStatus: string | undefined;
  onEvaluationStatusChange: (evaluationStatus?: string) => void;
  getPDFReport: () => void;
  loading: boolean;
}) => {
  const isSubmitButtonDisabled = () => {
    if (periodFrom && periodTo && min != null && max != null) {
      return false;
    }
    return true;
  };

  return (
    <div className={"report-sidebar"}>
      <div className={"report-param-title"}>
        <Typography.Title style={{ fontSize: 14 }}>
          {translate("report2.period")}
        </Typography.Title>
        <DatePicker
          style={{ marginBottom: "1em" }}
          placeholder={translate("report2.period_from")}
          value={periodFrom ? moment(periodFrom) : undefined}
          onChange={(date, dateString) => {
            date && onPeriodFromChange(date.toDate());
          }}
          locale={{ dateFormat: DateFormats.DATE }}
          showToday={false}
        ></DatePicker>
        <DatePicker
          style={{ marginBottom: "1em" }}
          placeholder={translate("report2.period_to")}
          value={periodTo ? moment(periodTo) : undefined}
          onChange={(date, dateString) => {
            date && onPeriodToChange(date.toDate());
          }}
          locale={{ dateFormat: DateFormats.DATE }}
          showToday={false}
        ></DatePicker>
      </div>
      <div className={"report-param-title"}>
        <Typography.Title style={{ fontSize: 14 }}>
          {translate("report2.evaluation_number")}
        </Typography.Title>
        <InputNumber
          style={{ marginBottom: "1em" }}
          placeholder={translate("report2.min")}
          value={min}
          onChange={(value) => onMinChange(value)}
          min={0}
        ></InputNumber>
        <InputNumber
          placeholder={translate("report2.max")}
          value={max}
          onChange={(value) => onMaxChange(value)}
          min={0}
        ></InputNumber>
      </div>
      <div className={"report-param-title"}>
        <Typography.Title style={{ fontSize: 14, marginTop: 10 }}>
          {translate("report2.evaluation_status")}
        </Typography.Title>
        <SelectInput
          value={evaluationStatus}
          placeholder={translate("report2.choose_evaluation_status")}
          selectOptions={EvaluationStatuses}
          selectOptionKey={"id"}
          selectOptionValue={"id"}
          style={{ width: "100%" }}
          onChange={(value) => onEvaluationStatusChange(value)}
          defaultActiveFirstOption={false}
          allowClear={true}
          showSearch={true}
          notFoundContent={translate("search.no_data")}
        />
      </div>
      <Button
        className={"report-btn"}
        type="primary"
        onClick={getPDFReport}
        loading={loading}
        disabled={isSubmitButtonDisabled()}
      >
        {translate("reports.show")}
      </Button>
    </div>
  );
};

export default Report2ParamBox;
